export default __webpack_public_path__ + "unlock-c9bd544a9a1020d053514b2bfd14b5d2.svg";